// extracted by mini-css-extract-plugin
module.exports = {"container":"AiAddendum_container__2vGmK","button":"AiAddendum_button__3z-NX"};